import {createReducer} from "redux-act";
import {fetchRewardStatsSuccess} from "modules/actions/rewardStats";

const initialState = {
	rewards: [],
};
export const rewards = createReducer<ReturnType<typeof fetchRewardStatsSuccess>["payload"]>(
	{},
	initialState
);
rewards.on(fetchRewardStatsSuccess, (state, payload) => payload);
